import AdsError from './AdsError.js'

export class GetSubscriptionSearchResultsInvalidRequestAdsError extends AdsError {}
